import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { ConfigRouteParamsRequest, PaginationDataObject } from '#models';
import type { MessageDataObject } from '#models/services';
import { routes } from '#routes';

type GetChatroomMessagesRequest = paths['/chatrooms/{chatroomId}/messages']['get']['parameters']['query'];
type MessagesPathRequestParams = paths['/chatrooms/{chatroomId}/messages']['get']['parameters']['path'];

export const getChatroomMessages = async ({
  config,
  routeParams: { chatroomId },
}: ConfigRouteParamsRequest<GetChatroomMessagesRequest, MessagesPathRequestParams>) =>
  getNodeApiAxiosInstance().get<
    PaginationDataObject<MessageDataObject>,
    AxiosResponse<PaginationDataObject<MessageDataObject>>
  >(routes.chatrooms.messages.get(chatroomId), config);
